import * as styles from "./container.module.sass"
import classNames from "classnames";
import React from "react";
import { DoubleText } from "../../molecules/DoubleText";

export const DoubleTextContainer = (props: any) => {

    const classProps: string = classNames(styles.search_stats, props.className);
    
    return (
        <div className={classProps}>
            {props.video_info.map((t: any, key: any) => <DoubleText key={key} title={`+${t.number}`} subtitle={t.title} />)}
        </div>
    );
};



